module.exports = __webpack_public_path__ + "img/map_westkant.3d7aa22e.png";